import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import { Link } from "react-router-dom";
import { Calendar, Clock, ArrowRight } from "lucide-react";

const blogPosts = [
  {
    slug: "how-turning-on-my-camera-boosted-my-productivity",
    title: "How Turning on my Camera Boosted my Productivity",
    excerpt: "I used to think that I could never study at home. That's because when I'm in my room, there's no one watching and no pressure to push. My room was therefore my biggest productivity trap.",
    date: "2024-12-07",
    readTime: "8 min read",
    category: "Productivity"
  }
];

const Blog = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <SEO 
        title="Blog - Productivity Tips & Study Guides"
        description="Discover productivity tips, study techniques, and insights on how to stay focused with online study rooms. Learn from real experiences and boost your productivity."
        keywords="productivity blog, study tips, online study rooms, focus techniques, study with me, productivity hacks"
        canonicalUrl="/blog/"
      />
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-primary/5 via-background to-background" />
        <div className="absolute top-20 left-1/4 w-96 h-96 bg-primary/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-secondary/10 rounded-full blur-3xl" />
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <span className="inline-block px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6">
              CSW Blog
            </span>
            <h1 className="text-4xl md:text-6xl font-display font-bold mb-6">
              Productivity <span className="text-gradient">Insights</span> & Tips
            </h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Real stories, practical advice, and study techniques to help you stay focused and achieve your goals.
            </p>
          </div>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            {blogPosts.map((post) => (
              <Link 
                key={post.slug}
                to={`/blog/${post.slug}/`}
                className="group block"
                onClick={() => window.scrollTo(0, 0)}
              >
                <article className="bg-card border border-border rounded-2xl p-8 hover:border-primary/50 transition-all duration-300 hover:shadow-lg hover:shadow-primary/5">
                  <div className="flex items-center gap-4 mb-4">
                    <span className="px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-medium">
                      {post.category}
                    </span>
                    <div className="flex items-center gap-2 text-muted-foreground text-sm">
                      <Calendar className="w-4 h-4" />
                      <span>{new Date(post.date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</span>
                    </div>
                    <div className="flex items-center gap-2 text-muted-foreground text-sm">
                      <Clock className="w-4 h-4" />
                      <span>{post.readTime}</span>
                    </div>
                  </div>
                  
                  <h2 className="text-2xl md:text-3xl font-display font-bold mb-4 group-hover:text-primary transition-colors">
                    {post.title}
                  </h2>
                  
                  <p className="text-muted-foreground mb-6 line-clamp-3">
                    {post.excerpt}
                  </p>
                  
                  <div className="flex items-center gap-2 text-primary font-medium">
                    Read More <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </div>
                </article>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Blog;
